import { createActionColumn } from "@components/shared/actionColumn";
import { deleteParticipant } from "@services/api";

export const getColumnDefs = (
  handleCellValueChanged: (params: any) => Promise<void>,
  handleDeleteSuccess: () => Promise<void>,
) => [
  {
    headerName: "ID",
    field: "id",
    sortable: true,
    width: 50,
    suppressMovable: true,
    resizable: false,
  },
  {
    headerName: "Имя",
    field: "name",
    sortable: true,
    sort: "asc",
    filter: true,
    resizable: false,
    flex: 1,
    minWidth: 150,
    suppressMovable: true,
    editable: true,
    onCellValueChanged: handleCellValueChanged,
  },
  createActionColumn({
    icon: "X",
    type: "delete",
    onClick: (data) => {
      if (
        window.confirm(
          "Вы уверены, что хотите удалить этого участника? Это также удалит все связанные транзакции и посещения.",
        )
      ) {
        deleteParticipant(data.id)
          .then(() => {
            handleDeleteSuccess();
          })
          .catch((error) => {
            console.error("Ошибка:", error);
            alert("Ошибка удаления участника");
          });
      }
    },
  }),
];
